import { Col, Container, Row } from 'react-bootstrap'
import illustration1 from '../assets/images/g10.svg'
import Header from '../components/Header'
import LoginForm from './LoginForm'

const Login = () => {
  return (
    <>
      <Header />
      <main>
        <section className='login-form-section'>
          <Container>
            <Row>
              <Col lg={6} className='py-4 heading-container d-none d-lg-block'>
                <img src={illustration1} alt='g10' />
                <h2>Neuro Electrical Mind for All</h2>
                <p>NEMA AI is a neuroscience and AI based consumer insight platform which makes learning , branding & marketing efficient.</p>
              </Col>
              <Col lg={6} className='o-1'>
                <LoginForm />
              </Col>
            </Row>
          </Container>
        </section>
      </main>
    </>
  )
}

export default Login
